import * as React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import {
  TypographyH4White,
  TypographyH5White
} from '../../../features/estimatingRequirements/peng2018/style';
import { TextWithInfoIcon } from '../textWithInfoIcon';
import {
  TypographyBg18Bold,
  TypographyCalibri16Italic,
  TypographyCalibri24Bold
} from '../../../features/compare/style';

export const DoubleTextBlueCard = ({
  heading1,
  heading2,
  miniHeading1,
  miniHeading2,
  label1,
  label2,
  icon,
  unit1,
  unit2,
  miniHeadingSize,
  mb,
  infoIconRequired = false,
  handleInfoIconClick,
  infoIcon,
  infoIconTestId,
  isCompare = false,
  customTopInfoIcon
}: {
  heading1?: string;
  heading2?: string;
  miniHeading1?: string;
  miniHeading2?: string;
  label1: string;
  label2?: string;
  icon: any;
  unit1?: string;
  unit2?: string;
  mb?: string;
  miniHeadingSize?: string;
  infoIconRequired?: boolean;
  handleInfoIconClick?: () => void;
  infoIcon?: string;
  infoIconTestId?: string;
  isCompare?: boolean;
  customTopInfoIcon?: string;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        backgroundColor: '#004F71',
        borderRadius: '0.9375rem',
        padding: '0.9375rem'
      }}
      mb={mb}
    >
      {/* code for circle with 45px width and height with bg color as yellow */}
      <Box
        sx={{
          width: '1.8125rem',
          height: '1.8125rem',
          backgroundColor: '#004F71',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '0.3125rem solid #FFF',
          position: 'relative',
          top: '-35px',
          padding: '0.3125rem'
        }}
      >
        <img src={icon} alt="scale" />
      </Box>

      {heading1 && !infoIconRequired && !isCompare && (
        <TypographyH4White
          variant="body1"
          sx={{
            marginBottom: '-0.625rem',
            marginTop: '-0.625rem',
            textTransform: 'uppercase',
            textAlign: 'center',
            margin: '0.625rem'
          }}
        >
          {heading1}
        </TypographyH4White>
      )}

      {heading1 && isCompare && (
        <TypographyBg18Bold
          sx={{ marginTop: '-0.625rem', marginBottom: '1.25rem' }}
        >
          {heading1}
        </TypographyBg18Bold>
      )}

      {infoIconRequired && infoIcon && handleInfoIconClick && heading1 && (
        <TextWithInfoIcon
          title={heading1}
          icon={infoIcon}
          fontSize={'1.125rem'}
          lineHeight={'1.375rem'}
          variant={'h4'}
          fontColor={'#fff'}
          handleIconClick={handleInfoIconClick}
          testId={infoIconTestId}
          boxHeight="auto"
          customTopInfoIcon={customTopInfoIcon}
        />
      )}

      <Box
        sx={{
          marginTop: miniHeading1 ? 0 : 2,
          display: 'block',
          textAlign: 'center'
        }}
      >
        {miniHeading1 && !miniHeadingSize && !isCompare && (
          <TypographyH4White
            variant="body1"
            sx={{
              marginBottom: '-0.625rem',
              marginTop: '-0.625rem',
              textTransform: 'uppercase',
              textAlign: 'center',
              margin: '0.625rem'
            }}
          >
            {miniHeading1}
          </TypographyH4White>
        )}

        {miniHeading1 && miniHeadingSize && !isCompare && (
          <TypographyH5White
            variant="body1"
            sx={{
              marginBottom: '-0.625rem',
              marginTop: '-0.625rem',
              textTransform: 'uppercase',
              textAlign: 'center',
              margin: '0.625rem'
            }}
          >
            {miniHeading1}
          </TypographyH5White>
        )}

        {miniHeading1 && isCompare && (
          <TypographyCalibri24Bold>{miniHeading1}</TypographyCalibri24Bold>
        )}
        {label1 && !isCompare && (
          <Typography
            variant="body2"
            sx={{
              fontFamily: 'Calibri',
              fontWeight: 700,
              fontSize: '35px',
              color: '#fff',
              lineHeight: '3.125rem'
            }}
          >
            {label1}
            {unit1 && <span dangerouslySetInnerHTML={{ __html: unit1 }}></span>}
          </Typography>
        )}

        {label1 && isCompare && (
          <TypographyCalibri16Italic>{label1}</TypographyCalibri16Italic>
        )}
      </Box>
      {label2 && (
        <Divider
          sx={{
            backgroundColor: '#fff',
            my: 2,
            width: '25%',
            mx: 'auto'
          }}
        />
      )}
      <Box
        sx={{
          marginTop: miniHeading2 ? 0 : 2,
          display: 'block',
          textAlign: 'center',
          marginBottom: miniHeading2 ? 1 : 0
        }}
      >
        {miniHeading2 && !isCompare && (
          <TypographyH4White
            variant="body1"
            sx={{
              marginBottom: '-0.625rem',
              marginTop: '-0.625rem',
              textTransform: 'uppercase',
              textAlign: 'center',
              margin: '0.625rem'
            }}
          >
            {miniHeading2}
          </TypographyH4White>
        )}

        {miniHeading2 && isCompare && (
          <TypographyCalibri24Bold>{miniHeading2}</TypographyCalibri24Bold>
        )}

        {heading2 && (
          <Typography
            variant="body1"
            sx={{
              fontFamily: 'Brandon Grotesque',
              fontWeight: 450,
              fontSize: '1.125rem',
              color: '#fff',
              lineHeight: '1.25rem',
              textTransform: 'uppercase',
              textAlign: 'center'
            }}
          >
            {heading2}
          </Typography>
        )}
        {label2 && !isCompare && (
          <Typography
            variant="body2"
            sx={{
              fontFamily: 'Calibri',
              fontWeight: 700,
              fontSize: '35px',
              color: '#fff',
              lineHeight: '3.125rem'
            }}
          >
            {label2}
            {unit2 && <span dangerouslySetInnerHTML={{ __html: unit2 }}></span>}
          </Typography>
        )}

        {label2 && isCompare && (
          <TypographyCalibri16Italic>{label2}</TypographyCalibri16Italic>
        )}
      </Box>
    </Box>
  );
};
